<template>
    <div class="media-picker">
        <div class="picker-content">
            <div class="pr-3 has-text-right close-bar" v-if="type"><i class="fas fa-times fa-2x p-2 is-clickable" @click="$emit('close')"></i></div>

            <div class="picker-browser">
                <browser :type="type" @choose="(choice) => $emit('choose', choice)" />
            </div>
        </div>
    </div>
</template>

<script>
    import Browser from "./Browser";

    export default {
        components: {Browser},
        props: ['type'],
        data: function () {
            return {};
        }
    };
</script>

<style lang="scss" scoped>
    .media-picker {
        border-radius: 0.5rem;
        z-index: 1000;
        background-color: white;
        position: fixed;
        top: 20px;
        left: 20px;
        right: 20px;
        bottom: 20px;
    }

    .picker-content {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .close-bar {
        flex: 0;
    }

    .picker-browser {
        flex-grow: 1;
        overflow-y: auto;
        border-top: 1px solid #e0e0e0;
    }
</style>
